import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import styles from "./styles/Menu.module.scss";
import { RiLockPasswordFill } from "react-icons/ri";
import { FaUser } from "react-icons/fa";
import { MdQuestionAnswer } from "react-icons/md";

import { ROUTES } from "./contants";

const SETTING_COPY_ADMIN =
  "Manage your account preferences and system configurations. You can update your password, profile, and platform settings to ensure a secure and personalized admin experience.";

const SETTING_COPY_AGENT =
  "Update your account password. Use a strong password to keep your agent account secure.";

export default function Menu({ route, setRoute }) {
  const portal = useSelector((state) => state.auth?.portal);
  const isAgent = portal === "agent";

  const OPTIONS = useMemo(
    () => {
      const all = [
        {
          label: "Change Password",
          route: ROUTES.CHANGE_PASSWORD,
          icon: RiLockPasswordFill,
        },
        {
          label: "Profile",
          route: ROUTES.EDIT_PROFILE,
          icon: FaUser,
        },
        {
          label: "FAQ Management",
          route: ROUTES.FAQ_MANAGEMENT,
          icon: MdQuestionAnswer,
        },
      ];
      if (isAgent) {
        return all.filter((item) => item.route === ROUTES.CHANGE_PASSWORD);
      }
      return all;
    },
    [isAgent]
  );

  return (
    <div className={styles.Menu}>
      <h2 className={styles.title}>Setting</h2>
      <p className={styles.intro}>
        {isAgent ? SETTING_COPY_AGENT : SETTING_COPY_ADMIN}
      </p>
      {OPTIONS.map((item) => {
        const Icon = item.icon;
        const active = route === item.route;
        return (
          <button
            type="button"
            key={item.route}
            className={`${styles.option} ${active ? styles.active : ""}`}
            onClick={() => setRoute(item.route)}
          >
            <span className={styles.iconWrap}>
              <Icon className={styles.icon} size={20} aria-hidden />
            </span>
            <span className={styles.optionLabel}>{item.label}</span>
          </button>
        );
      })}
    </div>
  );
}
